import React, { Component } from 'react';

import TicketBox from './TicketBox';
import IconTicket from '../../assets/icons/IconTicket';
import IconTicketChecked from '../../assets/icons/IconTicketChecked';
import IconTicketHistory from '../../assets/icons/IconTicketHistory';
import IconTicketHistorySecond from '../../assets/icons/IconTicketHistorySecond';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';

class TicketBoxListPrincipal extends Component {
    filterStatus = status => {
        if (status === 'open') {
            const filtered = this.props.data.filter((ticket) => ticket.status === STATUS_TICKET_CONSTANT.UNASSIGNED || ticket.status === STATUS_TICKET_CONSTANT.ASSIGNED);
            return filtered.length;
        }

        if (status === 'inprogress') {
            const filtered = this.props.data.filter((ticket) => ticket.status === STATUS_TICKET_CONSTANT.IN_PROGRESS || ticket.status === STATUS_TICKET_CONSTANT.ON_HOLD);
            return filtered.length;
        }

        if (status === 'closed') {
            const filtered = this.props.data.filter((ticket) => ticket.status === STATUS_TICKET_CONSTANT.CLOSED || ticket.status === STATUS_TICKET_CONSTANT.RESOLVED || ticket.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION);
            return filtered.length;
        }
    };

    filterDataTracker = status => {
        if (status === 'open') {
            const filtered = this.props.data.filter((ticket) => ticket.status === STATUS_TICKET_CONSTANT.UNASSIGNED || ticket.status === STATUS_TICKET_CONSTANT.ASSIGNED);
            return filtered.sort((a, b) => b.ticket_no.localeCompare(a.ticket_no));
        }

        if (status === 'inprogress') {
            const filtered = this.props.data.filter((ticket) => ticket.status === STATUS_TICKET_CONSTANT.IN_PROGRESS || ticket.status === STATUS_TICKET_CONSTANT.ON_HOLD);
            return filtered.sort((a, b) => b.ticket_no.localeCompare(a.ticket_no));
        }

        if (status === 'closed') {
            const filtered = this.props.data.filter((ticket) => ticket.status === STATUS_TICKET_CONSTANT.CLOSED || ticket.status === STATUS_TICKET_CONSTANT.RESOLVED || ticket.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION);
            return filtered.sort((a, b) => b.ticket_no.localeCompare(a.ticket_no));
        }

        if (status === 'all') {
            const filtered = this.props.data;
            return {
                whatsapp: filtered.filter((ticket) => ticket.tracker === 'chat').length,
                phone: filtered.filter((ticket) => ticket.tracker === 'phone').length,
                email: filtered.filter((ticket) => ticket.tracker === 'email').length,
                grochat: filtered.filter((ticket) => ticket.tracker === 'grochat').length,
                status
            };
        }
    }

    render() {
        return (
            <>
                {/* Dashboard Ticket box */}
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnopen" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker('open'))} titleTicket="terbuka" totalTicket={this.filterStatus('open')} iconTicket={<IconTicketHistory />} textColor="text-nexcarered1" iconBoxColor="bg-nexcarered1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btninprogress" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker('inprogress'))} titleTicket="dalam proses" totalTicket={this.filterStatus('inprogress')} iconTicket={<IconTicketHistorySecond />} textColor="text-nexcareorange1" iconBoxColor="bg-nexcareorange1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnclosed" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker('closed'))} titleTicket="ditutup" totalTicket={this.filterStatus('closed')} iconTicket={<IconTicketChecked />} textColor="text-nexcaregreen1" iconBoxColor="bg-nexcaregreen1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btntotalticket" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker('all'))} titleTicket="total tiket diterima" totalTicket={this.props.data.length} iconTicket={<IconTicket />} textColor="text-nexcareblue2" iconBoxColor="bg-nexcareblue2" />
                </div>
            </>
        );
    }
}

export default TicketBoxListPrincipal;